<template>
  <div>
    <el-dialog
        :visible.sync="dialogVisible"
        title="物料预览"
        width="1000px"
        top="5vh">
      <el-button type="primary" style="margin-bottom: 5px" @click="materialsAdd">添加</el-button>
      <vm-table
          ref="vmTable"
          :filter.sync="filter"
          method="get"
          module="basic"
          url="materials/supplierInfoId">
        <template slot="adSearch">
          <div class="vm-search">
            <vm-search label="物料编号：">
              <el-input v-model.trim="filter.no" clearable/>
            </vm-search>
            <vm-search label="物料名称：">
              <el-input v-model.trim="filter.name" clearable/>
            </vm-search>
            <vm-search label="物料组：">
              <el-input v-model.trim="filter.materialGroupNO" clearable/>
            </vm-search>
          </div>
        </template>
        <el-table-column prop="no" label="物料编号"/>
        <el-table-column prop="name" label="物料名称"/>
        <el-table-column prop="materialGroupNO" label="物料组编号"/>
        <el-table-column prop="productGroupNO" label="产品组编号"/>
        <el-table-column prop="purchaseGroupNO" label="采购组编号"/>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="danger" @click="deleteRow(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </vm-table>
    </el-dialog>
    <supplier-manage-material-list ref="materialsAdd" @save-success="getList(-1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import SupplierManageMaterialList from "@/views/information/SupplierManage/SupplierManageMaterialList";
  import VmSearch from "@/components/VmSearch.vue";
  export default {
    name: "SupplierManageMaterial",
    components: { SupplierManageMaterialList, VmTable, VmSearch },
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        filter: {
          no: "",
          name: "",
          materialGroupNO: "",
          supplierInfoId: "",
        },
      };
    },
    methods: {
      open(row) {
        this.filter.supplierInfoId = row.pkid;
        console.log(this.filter.supplierInfoId);
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      materialsAdd() {
        console.log(this.filter.supplierInfoId);
        this.$refs.materialsAdd.open(this.filter.supplierInfoId);
      },
      deleteRow(row) {
        console.log(row);
        let prams = [];
        prams.push(this.filter.supplierInfoId);
        prams.push(row.id);
        console.log(prams);
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.delete("basic", "supplierMaterials/idList", prams).then((resp) => {
            if (resp.success) {
              this.getList(-1);
              this.$message.success("删除成功");
            }
          });
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
